import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class NotificationsService {
    private apiUrl = environment.BASE_URL;
    private prefix = 'notification';

    constructor(private http: HttpClient) { }


    // Service to get notifications
    getNotifications(businessId: string): Observable<any> {
        const url = `${this.apiUrl}/${this.prefix}`;
        const headers = { 'Content-Type': 'application/json', 'x-business-id': businessId };
        return this.http.get(url, { headers });
    }

    // Service to send email
    sendEmail(subject: string, body: string, to: string, cc: string = ""): Observable<any> {
        const url = `${this.apiUrl}/admin/send-email`;
        const headers = { 'Content-Type': 'application/json' };
        const data = { email_subject: subject, email_body: body, email_to: to, email_cc: cc };
        return this.http.post(url, data, { headers });
    }

}
